// extracted by mini-css-extract-plugin
export default {"slidesEditor":"styles_slidesEditor__byexL"};